import {Pipe, PipeTransform} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

@Pipe({
    name: 'lsnCurrency'
})
export class LsnCurrencyPipe implements PipeTransform {
    constructor(private translateService: TranslateService) {
    }

    transform(value: number) {
        if (!value && value !== 0) {
            return '-';
        }
        return new Intl.NumberFormat('pl-PL', {style: 'currency', useGrouping: true, currency: 'PLN'}).format(value);
    }
}
